import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

type IconPosition = 'start' | 'end' | null;
type StandardButtonVariant = 'primary' | 'secondary';

@Component({
    selector: '[luiButton]',
    exportAs: 'luiButton',
    template: `
    <span class="lui-btn-container" matRipple>
      <span class="lui-btn-bg"></span>
      <span class="lui-btn-icon-container">
        <ng-content select="mat-icon"></ng-content>
      </span>
      <span [style.color]="isLoading ? 'transparent' : 'inherit'">
        <ng-content></ng-content>
      </span>
      <lui-circular-progress
        class="position-absolute"
        [ngClass]="isLoading ? 'd-block' : 'd-none'"
        diameter="20"
        mode="indeterminate"
      ></lui-circular-progress>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Button {
  private _model = 'lui-btn';

  @Input() iconPosition: IconPosition = null;

  @Input() get isLoading() {
    return this._isLoading;
  }
  set isLoading(value: BooleanInput) {
    this._isLoading = coerceBooleanProperty(value);
  }

  private _isLoading = false;

  @Input() variant: StandardButtonVariant = 'primary';

  @Input() disabled = false;

  @HostBinding('class') get hostClasses() {
    return {
      [this._model]: true,
      [`${this._model}-disabled`]: this.disabled,
      [`${this._model}-icon-${this.iconPosition}`]: this.iconPosition !== null,
      [`${this._model}-${this.variant}`]: this.variant !== null,
    };
  }

  @HostBinding('attr.disabled') get disabledAttr() {
    return this.disabled || this.isLoading || null;
  }

  @HostBinding('attr.tabindex') get tabIndex() {
    return this.disabled || this.isLoading ? -1 : 0;
  }
}
